// extracted by mini-css-extract-plugin
export default {"iconBtn":"SelectLangComponent_iconBtn__doTIZ","item":"SelectLangComponent_item__xWfl1","langIcon":"SelectLangComponent_langIcon__bGBRP"};